import { UIMatch } from "react-router-dom";

export interface Handle {
  crumb: (params: UIMatch["params"]) => { title: string };
}

export type UIMatchWithHandle = UIMatch<unknown, Handle>;

/**
 * The ReactRouter React Hook `useMatches` returns UIMatch<Data = unknown, Handle = unknown>[]
 * so we need to filter out the matches that have a handle with a crumb function via a type guard.
 *
 * @example
 * const initialMatches: UIMatch<unknown, unknown>[] = useMatches();
 * const matches = initialMatches.filter(isUIMatchWithHandle);
 *
 * => The type of `matches` is now UIMatch<unknown, Handle>[]
 */
export const isUIMatchWithHandle = (
  match: UIMatch,
): match is UIMatch<unknown, Handle> =>
  typeof match.handle === "object" &&
  match.handle !== null &&
  "crumb" in match.handle &&
  // NOTE: We can only check that `crumb` is a function and the number of its arguments but not
  // its types because during runtime, there are is no type information anymore.
  typeof match.handle.crumb === "function" &&
  match.handle.crumb.length === 1;
